/**
 * Retrieves the translation key from an `i18n-string` element within the given HTML element,
 * or falls back to the element's inner text if no `i18n-string` element is found.
 *
 * @param element - The HTML element to extract the translation key or inner text from.
 * @returns The translation key from the `i18n-string` element's `data-key` attribute,
 *          or the inner text of the provided element if no `i18n-string` element is present.
 */
export function getTranslationOrInnerText(element) {
  // Check if the button has an i18n-string element otherwise return the inner text
  const i18nElement = element === null || element === void 0 ? void 0 : element.querySelector('i18n-string[data-key]');
  return i18nElement ? i18nElement.getAttribute('data-key') : element.innerText;
}